/**
 * Created by yoavp on 12/15/2014.
 */

define(function (require) {
    "use strict";

    var Template = require("connection-templates/KPsTab/tabs.tmpl");
    var CP_CONST = require("connection-const");
    var TabsView = {};

    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        TabsView = Marionette.ItemView.extend({
            template: Template,
            className: 'cp-tabs-container',
            ui: {
                ticket: ".ticket",
                kps: ".kp",
                chat: ".chat",
                notification: ".notification-tab-button",
                tabNotificationsChatCounter: ".tab-notifications-chat-counter",
                tabNotificationsNotificationCounter: ".tab-notifications-notification-counter",
                notificationsNumberChat: ".notifications-number-chat",
                notificationsNumberNotification: ".tab-notifications-notification-counter .notifications-number-notification",
                kpsNewCounter: ".kp-notifications-counter",
                kpsNewCounterNumber: ".kp-notifications-counter .kp-notifications-counter-number"
            },

            events: {
                "click .ticket": "_showTicketTab",
                "click .kp": "_showKPsTab",
                "click .chat": "_showChatTab",
                "click .notification-tab-button": "_showNotificationTab"
            },

            modelEvents: {
                "change:chatNotificationsCounter": "_manageChatNotifications",
                "change:notificationCenterEventsCounter": "_manageNotificationCenterEventsProxy",
                "change:newKPsCounter": '_manageNewKPsCounter'
            },

            initialize: function (options) {
                this._connectionPanelContextModel = options.connectionPanelContextModel;
                this._visibility = options.visibility || {};
                this._bindEvents();
            },

            onRender: function () {
                this.isRendered = true;
                if (!this._visibility[CP_CONST.VISIBILITY.CASES]) {
                    this.ui.ticket.hide();
                    this.ui.ticket.addClass("no-width");
                    this._showKPsTab();
                }
                if (!this._visibility[CP_CONST.VISIBILITY.CHAT]) {
                    this.ui.chat.hide();
                    this.ui.chat.addClass("no-width");
                    if (!this._visibility[CP_CONST.VISIBILITY.CASES]) {
                        this.ui.ticket.addClass("no-width");
                    }
                }
                if (!this._visibility[CP_CONST.VISIBILITY.NOTIFICATION_CENTER]) {
                    this.ui.notification.hide();
                } else if (this._visibility[CP_CONST.VISIBILITY.CASES] && this._visibility[CP_CONST.VISIBILITY.CHAT]) {
                    this.ui.ticket.addClass("small-width");
                    this.ui.kps.addClass("small-width");
                    this.ui.notification.addClass("small-width");
                    this.ui.chat.addClass("small-width");
                }
                if (this._connectionPanelContextModel.getSelectedTab() === CP_CONST.TABS.NOTIFICATION) {
                    this._hideNotificationEvents(true);
                }
                if (this._connectionPanelContextModel.getSelectedTab() === CP_CONST.TABS.CONTENT) {
                    this._hideKPsCounter(true);
                }
            },

            _bindEvents: function () {
                LEConnection.vent.on("TabsView:selectKPsTab", this.selectKPsTab, this);
                LEConnection.vent.on("TabsView:selectChatTab", this.selectChatTab, this);
                LEConnection.vent.on("TabsView:selectNotificationTab", this.selectNotificationTab, this);
                LEConnection.vent.on("TabsView:selectTicketTab", this.selectTicketTab, this);
                this.listenTo(LEConnection.vent, "standalone:adjustments", this._adjustStandalone, this);
            },

            _adjustStandalone: function () {
                this.ui.kps.attr("tooltip-align", "left");
            },

            _showKPsTab: function (e) {
                LEConnection.vent.trigger("TabsController:switchTab", {tab: CP_CONST.TABS.CONTENT});
            },

            selectKPsTab: function () {
                this.ui.kps.addClass("is-selected");
                if (this.ui.chat.hasClass("is-selected")) {
                    this.ui.chat.removeClass("is-selected");
                }
                if (this.ui.ticket.hasClass("is-selected")) {
                    this.ui.ticket.removeClass("is-selected");
                }
                if (this.ui.notification.hasClass("is-selected")) {
                    this.ui.notification.removeClass("is-selected");
                }
                this._hideNotificationEvents(false);
                this._hideChatNotifications(false);
                this._hideKPsCounter(true);
            },

            _showChatTab: function (e) {
                LEConnection.vent.trigger("TabsController:switchTab", {tab: CP_CONST.TABS.CHAT});
            },

            selectChatTab: function () {
                this.ui.chat.addClass("is-selected");
                if (this.ui.ticket.hasClass("is-selected")) {
                    this.ui.ticket.removeClass("is-selected");
                }
                if (this.ui.kps.hasClass("is-selected")) {
                    this.ui.kps.removeClass("is-selected");
                }
                if (this.ui.notification.hasClass("is-selected")) {
                    this.ui.notification.removeClass("is-selected");
                }
                this._hideNotificationEvents(false);
                this._hideChatNotifications(true);
                this._hideKPsCounter(false);
            },

            _showNotificationTab: function (e) {
                LEConnection.vent.trigger("TabsController:switchTab", {tab: CP_CONST.TABS.NOTIFICATION});
            },

            selectNotificationTab: function () {
                this.ui.notification.addClass("is-selected");
                if (this.ui.chat.hasClass("is-selected")) {
                    this.ui.chat.removeClass("is-selected");
                }
                if (this.ui.kps.hasClass("is-selected")) {
                    this.ui.kps.removeClass("is-selected");
                }
                if (this.ui.ticket.hasClass("is-selected")) {
                    this.ui.ticket.removeClass("is-selected");
                }
                this._hideNotificationEvents(true);
                this._hideChatNotifications(false);
                this._hideKPsCounter(false);
            },

            _showTicketTab: function (e) {
                LEConnection.vent.trigger("TabsController:switchTab", {tab: CP_CONST.TABS.TICKET});
            },

            selectTicketTab: function () {
                this.ui.ticket.addClass("is-selected");
                if (this.ui.chat.hasClass("is-selected")) {
                    this.ui.chat.removeClass("is-selected");
                }
                if (this.ui.kps.hasClass("is-selected")) {
                    this.ui.kps.removeClass("is-selected");
                }
                if (this.ui.notification.hasClass("is-selected")) {
                    this.ui.notification.removeClass("is-selected");
                }
                this._hideNotificationEvents(false);
                this._hideChatNotifications(false);
                this._hideKPsCounter(false);
            },

            _manageChatNotifications: function (model, counter) {
                if (counter && counter > 0 && !this._isCurrentTab(CP_CONST.TABS.CHAT)) {
                    this.ui.notificationsNumberChat.text(counter);
                    this.ui.notificationsNumberChat.removeClass("hide");
                }
                else {
                    this.ui.notificationsNumberChat.addClass("hide");
                }
            },

            _manageNotificationCenterEventsProxy: function (model, value, options) {
                if (this.getIsRendered()) {
                    this._manageNotificationCenterEvents(model, value, options);
                } else {
                    this.listenToOnce(this, 'render', _.bind(function () {
                        this._manageNotificationCenterEvents(model, value, options);
                    }, this));
                }
            },

            _manageNotificationCenterEvents: function (model, value, options) {
                if (this._connectionPanelContextModel.getSelectedTab() !== CP_CONST.TABS.NOTIFICATION) {
                    if (value > 0) {
                        this.ui.notificationsNumberNotification.text(value);
                        this.ui.notificationsNumberNotification.removeClass("hide");
                    } else {
                        this._hideNotificationEvents(true);
                    }
                }
            },

            _manageNewKPsCounter: function (model, value, options) {
                if (this._connectionPanelContextModel.getSelectedTab() !== CP_CONST.TABS.CONTENT) {
                    if (value > 0) {
                        this.ui.kpsNewCounterNumber.text(value);
                        this.ui.kpsNewCounterNumber.removeClass("hide");
                    } else {
                        this._hideNotificationEvents(true);
                    }
                }
            },

            _hideNotificationEvents: function (hide) {
                if (hide) {
                    this.ui.notificationsNumberNotification.addClass("hide");
                } else {
                    var counter = this._connectionPanelContextModel.getNotificationsCounter();
                    if (counter > 0) {
                        this.ui.notificationsNumberNotification.text(counter);
                        this.ui.notificationsNumberNotification.removeClass("hide");
                    }
                }
            },
            _hideChatNotifications: function (hide) {
                if (hide) {
                    this.ui.notificationsNumberChat.addClass("hide");
                } else {
                    var counter = this._connectionPanelContextModel.get('chatNotificationsCounter');
                    if (counter > 0) {
                        this.ui.notificationsNumberChat.text(counter);
                        this.ui.notificationsNumberChat.removeClass("hide");
                    }
                }
            },

            _hideKPsCounter: function (hide) {
                if (hide) {
                    this.ui.kpsNewCounterNumber.addClass('hide');
                } else {
                    var counter = this._connectionPanelContextModel.getNewKPsCounter();
                    if (counter > 0) {
                        this.ui.kpsNewCounterNumber.text(counter);
                        this.ui.kpsNewCounterNumber.removeClass('hide');
                    }
                }
            },

            notificationCritical: function (urgent) {
                var that = this;
                if (this.getIsRendered()) {
                    this.ui.notificationsNumberNotification.toggleClass('critical', urgent);
                } else {
                    this.listenToOnce(this, 'render', _.bind(function () {
                        that.ui.notificationsNumberNotification.toggleClass('critical', urgent);
                    },this));
                }
            },

            _isCurrentTab: function (tab) {
                return this._connectionPanelContextModel.getSelectedTab() === tab;
            }
        });
    });

    return TabsView;
});

